'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Ldev_cheleb_scalamigen_config_PanelConfig(label, asTable, fieldCss, labelCss, panelCss) {
  this.lH = null;
  this.lF = false;
  this.lG = null;
  this.rT = null;
  this.lI = null;
  this.lH = label;
  this.lF = asTable;
  this.lG = fieldCss;
  this.rT = labelCss;
  this.lI = panelCss;
}
export { $c_Ldev_cheleb_scalamigen_config_PanelConfig as $c_Ldev_cheleb_scalamigen_config_PanelConfig };
$p = $c_Ldev_cheleb_scalamigen_config_PanelConfig.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ldev_cheleb_scalamigen_config_PanelConfig;
/** @constructor */
function $h_Ldev_cheleb_scalamigen_config_PanelConfig() {
}
export { $h_Ldev_cheleb_scalamigen_config_PanelConfig as $h_Ldev_cheleb_scalamigen_config_PanelConfig };
$h_Ldev_cheleb_scalamigen_config_PanelConfig.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  var acc = (-889275714);
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, (-1840279994));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.lH));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, (this.lF ? 1231 : 1237));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.lG));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.rT));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.lI));
  return $j_java$002elang$002e$002dObject.$m_sr_Statics$().an(acc, 5);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Ldev_cheleb_scalamigen_config_PanelConfig)) {
    if ((this.lF === x$0.lF)) {
      var x = this.lH;
      var x$2 = x$0.lH;
      var $x_1 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_1 = false;
    }
    if ((($x_1 && (this.lG === x$0.lG)) && (this.rT === x$0.rT))) {
      return (this.lI === x$0.lI);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.b = (function() {
  return $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().ah(this);
});
$p.n = (function() {
  return 5;
});
$p.o = (function() {
  return "PanelConfig";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.lH;
      break;
    }
    case 1: {
      return this.lF;
      break;
    }
    case 2: {
      return this.lG;
      break;
    }
    case 3: {
      return this.rT;
      break;
    }
    case 4: {
      return this.lI;
      break;
    }
    default: {
      throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__I__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Ldev_cheleb_scalamigen_config_PanelConfig(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.d8)));
}
export { $isArrayOf_Ldev_cheleb_scalamigen_config_PanelConfig as $isArrayOf_Ldev_cheleb_scalamigen_config_PanelConfig };
var $d_Ldev_cheleb_scalamigen_config_PanelConfig = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ldev_cheleb_scalamigen_config_PanelConfig, "dev.cheleb.scalamigen.config.PanelConfig", ({
  d8: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Ldev_cheleb_scalamigen_config_PanelConfig as $d_Ldev_cheleb_scalamigen_config_PanelConfig };
